<template>
    <v-container class="my-5">
        <!--    Diálogo Modal  Confirmar   -->
        <v-dialog v-model="dialogConfirm" max-width="290">
            <v-card>
                <v-card-title class="headline justify-center">{{$t('aviso')}}</v-card-title>
                <v-card-text align="center">
                    {{$t('msg_confirma_validacion_1')}} <b>{{$t('Si')}}</b> {{$t('or')}} <b> No </b> {{$t('msg_confirma_validacion_2')}}<br><br>
                    <v-btn color="primary" @click="dialogConfirm = false">{{$t('aceptar')}}</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal Persistente para mostrar la Info de Tutores y Estudiantes    -->
        <v-dialog v-model="dialogInfoTutorsAndTheirStudents" scrollable max-width="1000px">
            <v-card class="elevation-5">
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-account-details
                        </v-icon>
                        {{$t('tutors_and_students_data')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoTutorsAndTheirStudents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="userInfo.idTutor1 !== undefined">
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <br>
                            <h3>{{$t('datos_tutor')}}</h3>
                            <br>
                            <h4>Tutor 1</h4>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="edge pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="userInfo.idTutor1.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="edge pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="userInfo.idTutor1.idBack"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="userInfo.idTutor1.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="userInfo.idTutor1.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="userInfo.idTutor1.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="userInfo.idTutor1.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider/>
                            <br>
                            <h4>Tutor 2</h4>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="edge pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="userInfo.idTutor2.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="edge pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="userInfo.idTutor2.idBack"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="userInfo.idTutor2.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="userInfo.idTutor2.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="userInfo.idTutor2.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="userInfo.idTutor2.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider/>
                            <br>
                            <h2 class="red--text text--lighten-1 text-sm-center">{{$t('msg_recognize_tutors_students_2')}}</h2>
                            <br>
                            <h4>{{$t('estudiantes')}}</h4>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 md6 v-for="(student, i) in userInfo.student" v-bind:key="i">
                                    <v-avatar
                                            class="profile"
                                            color="grey"
                                            size="200"
                                    >
                                        <v-img
                                            :src="student.avatar"
                                            v-if="student.avatar"
                                        >
                                        </v-img>
                                    </v-avatar>
                                    {{student.first_name}} {{student.last_name}}
                                </v-flex>
                            </v-layout>
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions>
                    <v-layout wrap class="text-sm-center">
                        <v-flex xs12>
                            {{$t('msg_recognize_tutors_students')}}
                            <v-radio-group
                                    class="flex-center"
                                    row
                                    v-model="confirm"
                                    name="confirm"
                                    :mandatory="false"
                            >
                                <v-radio
                                        :label="$t('Si')"
                                        value=true
                                        outlined
                                ></v-radio>
                                <v-radio
                                        label="No"
                                        value=false
                                        outlined
                                ></v-radio>
                            </v-radio-group>
                        </v-flex>
                        <v-flex v-if="confirm === 'false'">
                            <v-textarea
                                v-model="feedback"
                                outlined
                                :placeholder="$t('msg_additional_comments')"
                                :label="$t('additional_comments')">
                            </v-textarea>
                        </v-flex>
                        <v-flex xs12>
                            <v-btn
                                    class="align-center"
                                    color="primary"
                                    large
                                    :loading="loading"
                                    @click="activateDeleteTutorsAndStundents(userInfo.id)"
                            >
                                {{$t('enviar')}}                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Dialogo para modificar datos de los tutores    -->
        <v-dialog v-model="dialogChangeDataTutor" max-width="600">
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-toolbar-title>
                <v-icon
                    right
                    dark
                >
                  mdi-account-details
                </v-icon>
                {{$t('change')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogChangeDataTutor = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                      class="pl-3 pr-3 pt-3"
                      prepend-icon="mdi-account"
                      :label="$t('Nombre')"
                      v-model="dataTutor.first_name"
                      :error-messages="errores.first_name"
                      outlined
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 >
                  <v-text-field
                      class="pl-3 pr-3"
                      prepend-icon="mdi-account-outline"
                      :label="$t('Apellido')"
                      v-model="dataTutor.last_name"
                      :error-messages="errores.last_name"
                      outlined
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                      class="pl-3 pr-3"
                      prepend-icon="mdi-email"
                      label="E-Mail"
                      v-model="dataTutor.email"
                      :error-messages="errores.email"
                      outlined
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  color="primary"
                  @click="dialogChangeDataTutor = false"
              >
                {{$t('cerrar')}}
              </v-btn>
              <v-spacer/>
              <v-btn
                  color="primary"
                  :loading="loading"
                  @click="changeTutorData"
              >
                {{$t('modificar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--    Dialogo para modificar datos de los Estudiantes    -->
        <v-dialog v-model="dialogChangeDataStudent" max-width="500">
          <v-card>
            <v-toolbar
                dark
                color="primary"
            >
              <v-toolbar-title>
                <v-icon
                    right
                    dark
                >
                  mdi-account-details
                </v-icon>
                {{$t('change')}}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn
                  class="align-self-end"
                  color="red"
                  icon
                  @click="dialogChangeDataStudent = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                      class="pl-3 pr-3 pt-3"
                      prepend-icon="mdi-account"
                      :label="$t('Nombre')"
                      v-model="dataStudent.first_name"
                      :error-messages="errores.first_name"
                      outlined
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 >
                  <v-text-field
                      class="pl-3 pr-3"
                      prepend-icon="mdi-account-outline"
                      :label="$t('Apellido')"
                      v-model="dataStudent.last_name"
                      :error-messages="errores.last_name"
                      outlined
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-autocomplete
                      class="pl-3 pr-3"
                      v-model="dataStudent.idClassroom"
                      prepend-icon="mdi-google-classroom"
                      :item-text="example"
                      item-value="id"
                      :label="$t('classrooms')"
                      :filter="customFilterClassroom"
                      :items="classrooms"
                      :error-messages="errores.idClassroom"
                      no-data-text="Ningún Resultado"
                      clearable
                      outlined
                      autocomplete="off"
                  >
                    <template v-slot:item="data">
                      <strong>{{data.item.grade_name === null ? 'n/a' : data.item.grade_name}} {{data.item.name === null ? 'n/a' : data.item.name}}</strong>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn
                  color="primary"
                  @click="dialogChangeDataStudent = false"
              >
                {{$t('cerrar')}}
              </v-btn>
              <v-spacer/>
              <v-btn
                  color="primary"
                  :loading="loading"
                  @click="changeStudentData"
              >
                {{$t('modificar')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <v-layout class="my-4" align-center justify-center fill-height>
        <v-flex v-if="tutorsAndTheirStudents.length > 0">
          <v-carousel
              height="auto"
              hide-delimiter-background
              show-arrows-on-hover
              hide-delimiters
          >
            <v-carousel-item
                v-for="(item,i) in tutorsAndTheirStudents"
                :key="i"
            >
              <v-card light>
                <v-toolbar color="primary" class="white--text">
                  <v-toolbar-title>
                    [  {{i + 1}} {{$t('de')}} {{tutorsAndTheirStudents.length}}  ]
                    <v-icon right dark>
                      mdi-account-details
                    </v-icon>
                    {{$t('tutors_and_students_data')}}
                  </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <br>
                  <h3>{{$t('datos_tutor')}}</h3>
                  <br>
                  <h4>Tutor 1</h4>
                  <v-btn icon @click="errores = [], setTutorData(item.idTutor1, i, 1)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <br>
                  <v-layout row wrap>
                    <v-flex
                        class="edge pl-3 pr-3 pt-3 pb-3"
                        xs12 sm6
                    >
                      <v-img
                          readonly
                          outlined
                          :src="item.idTutor1.idFront"
                      ></v-img>
                    </v-flex>
                    <v-flex
                        class="edge pl-3 pr-3 pt-3 pb-3"
                        xs12 sm6
                    >
                      <v-img
                          readonly
                          outlined
                          :src="item.idTutor1.idBack"
                      ></v-img>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-account"
                          :label="$t('Nombre')"
                          :value="item.idTutor1.first_name"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-account-outline"
                          :label="$t('Apellido')"
                          :value="item.idTutor1.last_name"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-email"
                          label="E-Mail"
                          :value="item.idTutor1.email"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-cellphone"
                          :label="$t('celular')"
                          :value="item.idTutor1.cellNumber"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <br>
                  <h4>Tutor 2</h4>
                  <v-btn icon @click="errores = [], setTutorData(item.idTutor2, i, 2)">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <br>
                  <v-layout row wrap>
                    <v-flex
                        class="edge pl-3 pr-3 pt-3 pb-3"
                        xs12 sm6
                    >
                      <v-img
                          readonly
                          outlined
                          :src="item.idTutor2.idFront"
                      ></v-img>
                    </v-flex>
                    <v-flex
                        class="edge pl-3 pr-3 pt-3 pb-3"
                        xs12 sm6
                    >
                      <v-img
                          readonly
                          outlined
                          :src="item.idTutor2.idBack"
                      ></v-img>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-account"
                          :label="$t('Nombre')"
                          :value="item.idTutor2.first_name"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-account-outline"
                          :label="$t('Apellido')"
                          :value="item.idTutor2.last_name"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-email"
                          label="E-Mail"
                          :value="item.idTutor2.email"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                          class="pl-3 pr-3"
                          prepend-icon="mdi-cellphone"
                          :label="$t('celular')"
                          :value="item.idTutor2.cellNumber"
                          readonly
                          outlined
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-divider/>
                  <br>
                  <h2 class="red--text text--lighten-1 text-sm-center">
                    {{$t('msg_recognize_tutors_students_2')}}
                  </h2>
                  <br>
                  <h4>{{$t('estudiantes')}}</h4>
                  <br>
                  <v-layout row wrap class="justify-center">
                    <v-flex xs12 sm6 lg4 v-for="(student, j) in item.student" v-bind:key="j">
                      <v-card class="text-center mt-3 mb-3 ml-3 mr-3">
                        <v-card-text class="justify-center">
                          <v-flex class="justify-center pt-3 pb-3 pl-3 pr-3">
                              <br>
                              <v-btn icon @click="errores = [], setStudentData(student, i, j)">
                                <v-icon>mdi-pencil</v-icon>
                              </v-btn>
                              <v-avatar
                                      class="profile"
                                      color="grey"
                                      size="200"
                              >
                                  <v-img :src="student.avatar"
                                      v-if="student.avatar"
                                  >
                                  </v-img>
                              </v-avatar>
                          </v-flex>
                          <v-text-field
                                  class="pl-3 pr-3"
                                  prepend-icon="mdi-account"
                                  :label="$t('Nombre')"
                                  :value="student.first_name"
                                  name="first_name"
                                  readonly
                                  outlined
                          >
                          </v-text-field>
                          <v-text-field
                                  class="pl-3 pr-3"
                                  prepend-icon="mdi-account-outline"
                                  :label="$t('Apellido')"
                                  :value="student.last_name"
                                  name="last_name"
                                  readonly
                                  outlined
                          >
                          </v-text-field>
<!--                          <v-autocomplete-->
<!--                                  v-model="idClassroomStudent"-->
<!--                                  prepend-icon="mdi-google-classroom"-->
<!--                                  name="idClassroom"-->
<!--                                  :item-text="example"-->
<!--                                  item-value="id"-->
<!--                                  :label="$t('classrooms')"-->
<!--                                  :filter="customFilterHouse"-->
<!--                                  :items="classrooms"-->
<!--                                  :error-messages="errores.idClassroom"-->
<!--                                  no-data-text="Ningún Resultado"-->
<!--                                  clearable-->
<!--                                  autocomplete="off"-->
<!--                          >-->
<!--                              <template v-slot:item="data">-->
<!--                                  <strong>{{data.item.grade_name === null ? 'n/a' : data.item.grade_name}} {{data.item.name === null ? 'n/a' : data.item.name}}</strong>-->
<!--                              </template>-->
<!--                          </v-autocomplete>-->
                        </v-card-text>
                      </v-card>
<!--                      <v-avatar-->
<!--                          class="profile"-->
<!--                          color="grey"-->
<!--                          size="200"-->
<!--                      >-->
<!--                        <v-img-->
<!--                            :src="student.avatar"-->
<!--                            v-if="student.avatar"-->
<!--                        >-->
<!--                        </v-img>-->
<!--                      </v-avatar>-->
<!--                      {{student.first_name}} {{student.last_name}}-->
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout wrap class="text-sm-center">
                    <v-flex xs12>
                      {{$t('msg_recognize_tutors_students')}}
                      <v-radio-group
                          class="flex-center"
                          row
                          v-model="confirm"
                          name="confirm"
                          :mandatory="false"
                      >
                        <v-radio
                            :label="$t('Si')"
                            value=true
                            outlined
                        ></v-radio>
                        <v-radio
                            label="No"
                            value=false
                            outlined
                        ></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex v-if="confirm === 'false'">
                      <v-textarea
                          v-model="feedback"
                          outlined
                          :placeholder="$t('msg_additional_comments')"
                          :label="$t('additional_comments')">
                      </v-textarea>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                          class="align-center"
                          color="success"
                          large
                          :loading="loading"
                          @click="printItem(item), activateDeleteTutorsAndStundents(item.id)"
                      >
                        {{$t('enviar')}}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-carousel-item>
          </v-carousel>
        </v-flex>
        <v-flex v-else>
          <p class="display-2 text-center">{{$t('sin_registros_aun')}}</p>
        </v-flex>
      </v-layout>

<!--        <v-layout class="my-4" align-center justify-center fill-height>-->
<!--            <v-flex >-->
<!--                <v-card-title>-->
<!--                    {{$t('new_records')}}-->
<!--                    <v-spacer></v-spacer>-->
<!--                </v-card-title>-->
<!--                <v-data-table-->
<!--                        :headers="headers"-->
<!--                        :loading="loadingTutorsAndStundents"-->
<!--                        :items="tutorsAndTheirStudents"-->
<!--                        class="elevation-1"-->
<!--                >-->
<!--                    <template v-slot:item.idTutor1.first_name="{ item }">-->
<!--                        {{item.idTutor1.first_name}}-->
<!--                        <br>-->
<!--                        {{item.idTutor2.first_name}}-->
<!--                    </template>-->
<!--                    <template v-slot:item.idTutor1.last_name="{ item }">-->
<!--                        {{item.idTutor1.last_name}}-->
<!--                        <br>-->
<!--                        {{item.idTutor2.last_name}}-->
<!--                    </template>-->
<!--                    <template v-slot:item.idTutor1.cellNumber="{ item }">-->
<!--                        {{item.idTutor1.cellNumber}}-->
<!--                        <br>-->
<!--                        {{item.idTutor2.cellNumber}}-->
<!--                    </template>-->
<!--                    <template v-slot:item.idTutor1.email="{ item }">-->
<!--                        {{item.idTutor1.email}}-->
<!--                        <br>-->
<!--                        {{item.idTutor2.email}}-->
<!--                    </template>-->
<!--                    <template v-slot:item.action="{ item }">-->
<!--                        <v-btn-->
<!--                                medium-->
<!--                                color="primary"-->
<!--                                class="mr-2"-->
<!--                                @click="userInfo = item, dialogInfoTutorsAndTheirStudents = true, confirm = null, feedback = null"-->
<!--                        >-->
<!--                            {{$t('validar')}}-->
<!--                        </v-btn>-->
<!--                    </template>-->
<!--                </v-data-table>-->
<!--            </v-flex>-->
<!--        </v-layout>-->
    </v-container>
</template>

<script>
import {HTTP} from '@/main.js'
import store from '@/store'
import {mapState} from 'vuex'

export default {
  name: "new_records",
  created () {
    this.getPreRegisteredTutorsAndTheirStudents()
    this.getClassrooms()
  },
  data: () => ({
    headers: [],
    tutorsAndTheirStudents: [],
    loadingTutorsAndStundents: false,
    loading: false,
    dialogInfoTutorsAndTheirStudents: false,
    userInfo: [],
    confirm: null,
    feedback: null,
    step: 1,
    dialogConfirm: false,
    dialogChangeDataTutor: false,
    dialogChangeDataStudent: false,
    dataTutor: {
      id: '',
      first_name: '',
      last_name: '',
      email: '',
      index: -1,
      number: -1
    },
    dataStudent: {
      id: '',
      first_name: '',
      last_name: '',
      idClassroom: '',
      indexi: -1,
      indexj: -1
    },
    classrooms: [],
    errores: []
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'idTutor1.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'idTutor1.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'left',
        sortable: true,
        value: 'idTutor1.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'left',
        sortable: true,
        value: 'idTutor1.email'
      }
    ]
  },
  computed: {
    ...mapState(['language'])
  },
  methods: {
    getClassrooms () {
      HTTP.get('classroom/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.classrooms = response.data
      })
      .catch(e => {
        console.log(e)
      })
    },
    getPreRegisteredTutorsAndTheirStudents () {
      this.loadingTutorsAndStundents = true
      HTTP.get('preregistration/list/', {
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      })
      .then(response => {
        this.tutorsAndTheirStudents = response.data
        this.loadingTutorsAndStundents = false
      })
      .catch(error => {
        console.log(error)
        this.loadingTutorsAndStundents = false
      })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    printItem (item) {
      console.log(item)
      // console.log('tutor1FN = ', this.item)
    },
    setTutorData (data, index, numberTutor) {
      this.dataTutor = {
        id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        email: data.email,
        index: index,
        number: numberTutor
      },
      this.dialogChangeDataTutor = true
      console.log(this.dataTutor)
    },
    setStudentData (data, indexi, indexj) {
      if (data.idClassroom === undefined) {
          this.dataStudent = {
          id: data.id,
          first_name: data.first_name,
          last_name: data.last_name,
          idClassroom: null,
          indexi: indexi,
          indexj: indexj
        }
      } else {
          this.dataStudent = {
          id: data.id,
          first_name: data.first_name,
          last_name: data.last_name,
          idClassroom: data.idClassroom,
          indexi: indexi,
          indexj: indexj
        }
      }
      this.dialogChangeDataStudent = true
      console.log(this.dataStudent)
    },
    changeTutorData () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()

      bodyFormData.set('first_name', this.dataTutor.first_name)
      bodyFormData.set('last_name', this.dataTutor.last_name)
      bodyFormData.set('email', this.dataTutor.email)
      HTTP.patch('users/update_data/' + this.dataTutor.id, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language
        }
      })
          .then(ok => {
            console.log(ok)
            if (this.dataTutor.number === 1){
              console.log('TUTOR UNO')
            }
            if (this.dataTutor.number === 2){
              console.log('TUTOR DOS')
            }
            console.log('INDEX = ', this.dataTutor.index)
            if (this.dataTutor.number === 1) {
              this.tutorsAndTheirStudents[this.dataTutor.index].idTutor1.first_name = this.dataTutor.first_name
              this.tutorsAndTheirStudents[this.dataTutor.index].idTutor1.last_name = this.dataTutor.last_name
              this.tutorsAndTheirStudents[this.dataTutor.index].idTutor1.email = this.dataTutor.email
            } else {
              this.tutorsAndTheirStudents[this.dataTutor.index].idTutor2.first_name = this.dataTutor.first_name
              this.tutorsAndTheirStudents[this.dataTutor.index].idTutor2.last_name = this.dataTutor.last_name
              this.tutorsAndTheirStudents[this.dataTutor.index].idTutor2.email = this.dataTutor.email
            }
            this.dialogChangeDataTutor = false
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
          .finally(() => (this.loading = false))
    },
    changeStudentData () {
      this.loading = true
      this.errores = []
      var bodyFormData = new FormData()


      console.log('INDEXS= ', this.dataStudent.indexi, this.dataStudent.indexj)
      console.log('Student Data= ', this.dataStudent)

      bodyFormData.set('first_name', this.dataStudent.first_name)
      bodyFormData.set('last_name', this.dataStudent.last_name)
      if (this.dataStudent.idClassroom !== undefined && this.dataStudent.idClassroom !== '' && this.dataStudent.idClassroom !== null) {
        bodyFormData.set('idClassroom', this.dataStudent.idClassroom)
      }
      HTTP.patch('prestudent/update_data/' + this.dataStudent.id, bodyFormData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'authorization': 'Token ' + store.getters.getToken,
          'Accept-Language': this.language
        }
      })
          .then(ok => {
            console.log(ok)
            console.log('INDEXS= ', this.dataStudent.indexi, this.dataStudent.indexj)

            this.tutorsAndTheirStudents[this.dataStudent.indexi].student[this.dataStudent.indexj].first_name = this.dataStudent.first_name
            this.tutorsAndTheirStudents[this.dataStudent.indexi].student[this.dataStudent.indexj].last_name = this.dataStudent.last_name
            this.tutorsAndTheirStudents[this.dataStudent.indexi].student[this.dataStudent.indexj].idClassroom = this.dataStudent.idClassroom

            this.dialogChangeDataStudent = false
            this.loading = false
          })
          .catch(error => {
            this.loading = false
            if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              this.errores = error.response.data
            }
          })
          .finally(() => (this.loading = false))
    },
    example: item => (item.grade_name === null ? 'n/a' : item.grade_name) + ' ' + (item.name === null ? 'n/a' : item.name),
    customFilterClassroom (item, queryText) {
      var text = ''
      if (item.grade_name === null || item.grade_name === '') {
        text = 'n/a'
      } else {
        text = item.grade_name.toLowerCase()
      }
      if (item.name === null || item.name === '') {
        text += ' n/a'
      } else {
        text +=  ' ' +  item.name.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    activateDeleteTutorsAndStundents (userUUID) {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        console.log('Activar Tutores y Estudiantes')
        this.loading = true
        HTTP.patch('preregistration/' + userUUID, {},
        {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        .then(ok => {
          console.log(ok)
          this.loading = false
          this.confirm = null
          this.feedback = null
          this.getPreRegisteredTutorsAndTheirStudents()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_tutors_students_validated'))
          this.dialogInfoTutorsAndTheirStudents = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
        .finally(() => (this.loading = false))
      } else {
        if (this.confirm === 'false') {
          console.log('Eliminar Tutores y Alumnos')
          this.loading = true
          HTTP.delete('preregistration/' + userUUID, {
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            },
            data: {
              'feedback': this.feedback
            }
          })
          .then(ok => {
            console.log(ok)
            this.loading = false
            this.confirm = null
            this.feedback = null
            this.getPreRegisteredTutorsAndTheirStudents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('msg_tutors_students_deleted'))
            this.dialogInfoTutorsAndTheirStudents = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            console.log(error)
            this.loading = false
          })
        }
      }
    }
  }
}
</script>

<style scoped>
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
